<template>
  <svg
    v-if="!outlined"
    style=""
    :width="handleSize"
    :height="handleSize"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.67826 2.92473L10.8256 6.07281L3.48034 13.4173H0.333008V10.2692L7.67826 2.92399V2.92473ZM8.72737 1.87562L10.301 0.301216C10.4402 0.162123 10.6289 0.0839844 10.8256 0.0839844C11.0223 0.0839844 11.211 0.162123 11.3501 0.301216L13.4491 2.40018C13.5882 2.53931 13.6663 2.728 13.6663 2.92473C13.6663 3.12147 13.5882 3.31015 13.4491 3.44929L11.8747 5.02295L8.72737 1.87562Z"
      :fill="`${color ? color : '#5138ee'}`"
    />
  </svg>
  <svg v-else
       xmlns="http://www.w3.org/2000/svg"
       :width="handleSize"
       :height="handleSize"
       viewBox="0 0 16 16"
       fill="none">
    <path
      d="M3.31602 11.0815L8.54214 5.85593L10.1409 7.45504L4.91466 12.6807H3.31602V11.0815ZM11.8995 5.69611L10.3006 4.09726L11.0601 3.33745L12.6593 4.93665L11.8995 5.69611Z"
      :stroke="color ? color : '#5138ee'" stroke-width="1"/>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'WcIconPencil',
  computed: {
    handleSize() {
      switch (this.$props.size) {
        case 'xl': return 28
        case 'lg': return 20
        case 'md': return 16
        case 'sm': return 14
        case 'xs': return 12
        default: return 16
      }
    }
  }
})
export default class extends Vue {
  @Prop({ default: '#ffffff' }) color!: String;
  @Prop({ default: 'md' }) private size!: String
  @Prop({ default: false }) private outlined!: boolean
}
</script>

<style scoped>
</style>
